/** @jsx jsx */

import { ReactNode } from 'react';

import { ButtonGroup, Colors } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

const Styles = {
  root: css`
    border-top: 1px solid ${Colors.GrayWarm3};
    padding: 28px 44px;
  `,
};

type WizardFooterProps = {
  children: ReactNode;
};

export const WizardFooter = (props: WizardFooterProps) => {
  return (
    <footer css={Styles.root}>
      <ButtonGroup justify="end">{props.children}</ButtonGroup>
    </footer>
  );
};

export default WizardFooter;
